import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { Helmet } from 'react-helmet-async';
import { filter } from 'lodash';
import { sentenceCase } from 'change-case';
import { useState, useEffect } from 'react';
// @mui
import {
  Card,
  Table,
  Stack,
  Paper,
  Avatar,
  Button,
  Popover,
  Checkbox,
  TableRow,
  MenuItem,
  TableBody,
  TableCell,
  Container,
  Typography,
  IconButton,
  TableContainer,
  TablePagination,
  TextField,
  Box,
  TableHead,
  Collapse,
} from '@mui/material';
import { DatePicker, LocalizationProvider, MuiPickersAdapterContext } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
// components
import Label from '../components/label';
import Iconify from '../components/iconify';
import Scrollbar from '../components/scrollbar';
// sections
import { UserListHead, UserListToolbar } from '../sections/@dashboard/user';
import { BACK } from '../config';

// ----------------------------------------------------------------------

function Menu2() {
  if (localStorage.getItem('id') === 'woosung') {
    return <></>;
  }
  return (
    <TableCell
      style={{ background: 'darkviolet', color: 'lightgray' }}
      onClick={() => {
        window.location.href = '/investigation';
      }}
    >
      <Typography variant="h4" gutterBottom>
        조사결과 조회
      </Typography>
    </TableCell>
  );
}
const TABLE_HEAD = [
  { id: 'name', label: 'Name', alignRight: false },
  { id: 'company', label: 'Company', alignRight: false },
  { id: 'role', label: 'Role', alignRight: false },
  { id: 'isVerified', label: 'Verified', alignRight: false },
  { id: 'status', label: 'Status', alignRight: false },
  { id: '' },
];

const TALBE_HEAD1 = [
  { id: 'id', label: 'ID', alignRight: false },
  { id: 'password', label: 'PASSWORD', alignRight: false },
  { id: 'name', label: 'NAME', alignRight: false },
  { id: 'phoneNum', label: 'PHONE_NUM', alignRight: false },
  { id: 'investCnt', label: 'INVEST_CNT', alignRight: false },
  { id: '' },
];

const TALBE_HEAD2 = [
  { id: 'idx', label: 'IDX', alignRight: false },
  { id: 'carNum', label: 'CAR_NUM', alignRight: false },
  { id: 'carType', label: 'CAR_TYPE', alignRight: false },
  { id: 'illegal', label: 'ILLEGAL', alignRight: false },
  { id: 'gradient', label: 'GRADIENT', alignRight: false },
  { id: 'longitude', label: 'LONGITUDE', alignRight: false },
  { id: 'latitude', label: 'LATITUDE', alignRight: false },
  { id: 'investor', label: 'INVESTOR', alignRight: false },
  { id: 'date', label: 'DATE', alignRight: false },
  { id: 'dayNight', label: 'DAY_NIGHT', alignRight: false },  
  { id: '' },
  { id: '' },
];

const TALBE_HEAD3 = [
  { id: 'idx', label: 'IDX', alignRight: false },
  { id: 'carNum', label: 'CAR_NUM', alignRight: false },
  { id: 'illegal', label: 'ILLEGAL', alignRight: false },
  { id: 'longitude', label: 'LONGITUDE', alignRight: false },
  { id: 'latitude', label: 'LATITUDE', alignRight: false },
  { id: 'date', label: 'DATE', alignRight: false },
  { id: 'dayNight', label: 'DAY_NIGHT', alignRight: false },
];
const CAR_TYPE_OPTIONS = [
  { value: 1, label: '승용/승합' },
  { value: 2, label: '소형트럭/버스(기존)' },
  { value: 3, label: '대형트럭/버스(기존)' },
  { value: 4, label: '기타(특수차량)' },
  { value: 5, label: '소형트럭/버스(비영업용)' },
  { value: 6, label: '소형트럭/버스(영업용)' },
  { value: 7, label: '대형트럭/버스(비영업용)' },
  { value: 8, label: '대형트럭/버스(영업용)' },
  { value: 9, label: '캠핑카' },
];

const getCarTypeName = (carType) => {
  const found = CAR_TYPE_OPTIONS.find((item) => item.value === Number(carType));
  return found ? found.label : '-';
};
// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query, orderBy) {
  if (array.length === 0) return array;
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(array, (_user) => _user[orderBy].toString().toLowerCase().indexOf(query.toLowerCase()) !== -1);
  }
  return stabilizedThis.map((el) => el[0]);
}

export default function InvestigationPage() {
  const [USERLIST, setUSERLIST] = useState([]);
  const [open, setOpen] = useState(null);

  const [page, setPage] = useState(0);

  const [order, setOrder] = useState('asc');

  const [selected, setSelected] = useState([]);

  const [orderBy, setOrderBy] = useState('investor');

  const [filterName, setFilterName] = useState('');

  const [rowsPerPage, setRowsPerPage] = useState(5);

  const [inputName, setInputName] = useState('');

  const [inputPhoneNum, setInputPhoneNum] = useState('');

  const [investigations, setInvestigations] = useState({});

  const [qCarType, setQCarType] = useState([false, false, false, false, false, false, false, false, false,]);

  const [qIllegal, setQIllegal] = useState([false, false]);

  const [qInvestor, setQInvestor] = useState([]);

  const [qId, setQId] = useState('');

  const [qDayNight, setQDayNight] = useState([false, false]);

  const [qDate, setQDate] = useState([
    { checked: false, date: dayjs(Date.now()) },
    { checked: false, date: dayjs(Date.now()) },
  ]);

  const [detail, setDetail] = useState(localStorage.getItem('detail'));

  dayjs.extend(utc);
  dayjs.extend(timezone);
  dayjs.tz.setDefault('Asia/Seoul');

  useEffect(() => {
    fetch(`${BACK}/readInvestor`, {
      method: 'GET',
    })
      .then((res) => {
        console.log(res.status);
        return res.json();
      })
      .then((data) => {
        console.log(data);
        setQInvestor(
          data.rows.map((item) => {
            return { id: item.id, checked: false };
          })
        );
      })
      .catch((err) => console.log(err));
  }, []);

  useEffect(() => {
    fetch(`${BACK}/readInvestigation`, {
      method: 'GET',
    })
      .then((res) => {
        console.log(res.status);
        return res.json();
      })
      .then((data) => {
        console.log(data);
        setUSERLIST(data.rows);
        setInvestigations(
          data.rows.reduce((ac, val, index) => {
            return { ...ac, [val.idx]: { latitude: val.latitude, longitude: val.longitude } };
          }, {})
        );
      });
  }, []);

  const deleteInvestigation = (idx) => {
    if (window.confirm('정말로 삭제하실건가요?')) {
      fetch(`${BACK}/deleteInvestigation`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          idx,
        }),
      })
        .then((res) => {
          console.log(res.status);
          return res.json();
        })
        .then((data) => {
          console.log(data);
          window.location.reload();
        });
    }
  };
  const updateInvestigation = ({ idx, investigations }) => {
    if (window.confirm('정말로 수정하실건가요?')) {
      fetch(`${BACK}/updateInvestigation`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          idx,
          latitude: investigations[idx].latitude,
          longitude: investigations[idx].longitude,
        }),
      })
        .then((res) => {
          console.log(res.status);
          return res.json();
        })
        .then((data) => {
          console.log(data);
          window.location.reload();
        });
    }
  };

  const handleOpenMenu = (event) => {
    setOpen(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setOpen(null);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = USERLIST.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
    }
    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setPage(0);
    setRowsPerPage(parseInt(event.target.value, 10));
  };

  const handleFilterByName = (event) => {
    setPage(0);
    setFilterName(event.target.value);
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - USERLIST.length) : 0;

  const filteredUsers = applySortFilter(USERLIST, getComparator(order, orderBy), filterName, orderBy);

  const isNotFound = !filteredUsers.length && !!filterName;

  return (
    <>
      <Helmet>
        <title> 창일 </title>
      </Helmet>

      <Container>
        <Stack direction="col" alignItems="center" justifyContent="space-between" mb={5}>
          <Table>
            <TableRow>
              <TableCell
                style={{ background: 'darkviolet', color: 'lightgray' }}
                onClick={() => {
                  window.location.href = '/';
                }}
              >
                <Typography variant="h4" gutterBottom>
                  조사자 관리
                </Typography>
              </TableCell>
              <Menu2 />
              <TableCell
                style={{ background: 'darkviolet', color: 'lightgray' }}
                onClick={() => {
                  window.location.href = '/personalInvestigation';
                }}
              >
                <Stack direction="col" justifyContent="space-between">
                  <Typography variant="h4" gutterBottom>
                    조사자별 조회
                  </Typography>
                  <Button
                    style={{ backgroundColor: 'white' }}
                    variant="outlined"
                    onClick={() => {
                      localStorage.removeItem('token');
                      localStorage.removeItem('id');
                      localStorage.removeItem('name');
                      localStorage.removeItem('type');
                      window.location.href = '/';
                    }}
                  >
                    로그아웃
                  </Button>
                </Stack>
              </TableCell>
            </TableRow>
          </Table>
        </Stack>

        <Card>
          <UserListToolbar
            numSelected={selected.length}
            filterName={filterName}
            onFilterName={handleFilterByName}
            orderBy={orderBy}
          />
          <Stack direction="col">
            <Typography variant="h4" gutterBottom margin={'20px'}>
              세부조건
            </Typography>
            <IconButton
              onClick={() => {
                if (detail === 'true') {
                  localStorage.setItem('detail', 'false');
                  setDetail('false');
                } else {
                  localStorage.setItem('detail', 'true');
                  setDetail('true');
                }
              }}
            >
              {detail === 'true' ? (
                <Iconify icon={'eva:arrow-ios-upward-outline'} sx={{ mr: 2 }} />
              ) : (
                <Iconify icon={'eva:arrow-ios-downward-outline'} sx={{ mr: 2 }} />
              )}
            </IconButton>
          </Stack>
          <Collapse in={detail === 'true'}>
            <Stack direction="col">
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell> </TableCell>
                    <TableCell>CAR_TYPE</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {CAR_TYPE_OPTIONS.map((item) => {
                    const arrayIndex = item.value - 1;

                    return (
                      <TableRow key={item.value}>
                        <TableCell padding="checkbox">
                          <Checkbox
                            checked={qCarType[arrayIndex]}
                            onChange={() => {
                              const temp = qCarType.map((checked, index) => {
                                if (index === arrayIndex) return !checked;
                                return checked;
                              });

                              setQCarType(temp);
                            }}
                          />
                        </TableCell>
                        <TableCell>{item.label}</TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell> </TableCell>
                    <TableCell>ILLEGAL</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    <TableCell padding="checkbox">
                      <Checkbox
                        checked={qIllegal[0]}
                        onChange={(event) => {
                          const temp = qIllegal.map((item, index) => {
                            if (index === 0) return !item;
                            return item;
                          });
                          setQIllegal(temp);
                        }}
                      />
                    </TableCell>
                    <TableCell>적법</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell padding="checkbox">
                      <Checkbox
                        checked={qIllegal[1]}
                        onChange={(event) => {
                          const temp = qIllegal.map((item, index) => {
                            if (index === 1) return !item;
                            return item;
                          });
                          setQIllegal(temp);
                        }}
                      />
                    </TableCell>
                    <TableCell>불법</TableCell>
                  </TableRow>
                </TableBody>
              </Table>
              <Container style={{ margin: 0, padding: 0, width: '100%' }}>
                <Table style={{ width: '100%' }}>
                  <TableHead style={{ postiion: 'sticky', top: 0 }}>
                    <TableRow>
                      <TableCell> </TableCell>
                      <TableCell>INVESTOR</TableCell>
                    </TableRow>
                  </TableHead>
                </Table>
                <Container
                  style={{ margin: 0, padding: 0, display: 'block', overflowY: 'auto', height: '25vh', width: '100%' }}
                >
                  <Table style={{ width: '100%' }}>
                    <TableBody>
                      {qInvestor.map((item, indexParent) => {
                        return (
                          <TableRow>
                            <TableCell padding="checkbox">
                              <Checkbox
                                checked={item.checked}
                                onChange={(event) => {
                                  const temp = qInvestor.map((item, index) => {
                                    if (index === indexParent)
                                      return {
                                        checked: !item.checked,
                                        id: item.id,
                                      };
                                    return item;
                                  });
                                  setQInvestor(temp);
                                }}
                              />
                            </TableCell>
                            <TableCell>{item.id}</TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </Container>
              </Container>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell />
                    <TableCell>DATE</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    <TableCell padding="checkbox">
                      <Checkbox
                        checked={qDate[0].checked}
                        onChange={(event) => {
                          const temp = qDate.map((item, index) => {
                            if (index === 0)
                              return {
                                checked: !item.checked,
                                date: item.date,
                              };
                            return item;
                          });
                          setQDate(temp);
                        }}
                      />
                    </TableCell>
                    <TableCell>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                          label="시작일"
                          onChange={(d) => {
                            setQDate(
                              qDate.map((item, index) => {
                                if (index === 0)
                                  return {
                                    checked: item.checked,
                                    date: dayjs(d),
                                  };
                                return item;
                              })
                            );
                          }}
                          defaultValue={qDate[0].date}
                        />
                      </LocalizationProvider>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell padding="checkbox">
                      <Checkbox
                        checked={qDate[1].checked}
                        onChange={(event) => {
                          const temp = qDate.map((item, index) => {
                            if (index === 1)
                              return {
                                checked: !item.checked,
                                date: item.date,
                              };
                            return item;
                          });
                          setQDate(temp);
                        }}
                      />
                    </TableCell>
                    <TableCell>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                          label="종료일"
                          onChange={(d) => {
                            setQDate(
                              qDate.map((item, index) => {
                                if (index === 1)
                                  return {
                                    checked: item.checked,
                                    date: dayjs(d),
                                  };
                                return item;
                              })
                            );
                          }}
                          defaultValue={qDate[1].date}
                        />
                      </LocalizationProvider>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell> </TableCell>
                    <TableCell>DAY_NIGHT</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    <TableCell padding="checkbox">
                      <Checkbox
                        checked={qDayNight[0]}
                        onChange={(event) => {
                          const temp = qDayNight.map((item, index) => {
                            if (index === 0) return !item;
                            return item;
                          });
                          setQDayNight(temp);
                        }}
                      />
                    </TableCell>
                    <TableCell>주간</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell padding="checkbox">
                      <Checkbox
                        checked={qDayNight[1]}
                        onChange={(event) => {
                          const temp = qDayNight.map((item, index) => {
                            if (index === 1) return !item;
                            return item;
                          });
                          setQDayNight(temp);
                        }}
                      />
                    </TableCell>
                    <TableCell>야간</TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </Stack>

            <br />
            <div style={{ width: '100%', justifyContent: 'center', alignContent: 'center', display: 'flex' }}>
              <Stack direction="col">
                <Button
                  variant="outlined"
                  onClick={() => {
                    setQCarType(
                      qCarType.map((item) => {
                        return false;
                      })
                    );
                    setQIllegal(
                      qIllegal.map((item) => {
                        return false;
                      })
                    );
                    setQInvestor(
                      qInvestor.map((item) => {
                        return { id: item.id, checked: false };
                      })
                    );
                    setQDate(
                      qDate.map((item) => {
                        return { date: item.date, checked: false };
                      })
                    );
                    setQDayNight(
                      qDayNight.map((item) => {
                        return false;
                      })
                    );
                  }}
                >
                  리셋
                </Button>
                &nbsp;&nbsp;&nbsp;
                <Button
                  variant="outlined"
                  onClick={() => {
                    const qCarTypeL = qCarType.filter((item) => item === true).length;
                    const qIllegalL = qIllegal.filter((item) => item === true).length;
                    const qDateL = qDate.filter((item) => item.checked === true).length;
                    const qDayNightL = qDayNight.filter((item) => item === true).length;
                    fetch(`${BACK}/searchInvestigation`, {
                      method: 'POST',
                      headers: {
                        'Content-Type': 'application/json',
                      },
                      body: JSON.stringify({
                        carType: qCarTypeL === 9 || qCarTypeL === 0 ? [] : qCarType,
                        illegal: qIllegalL === 2 || qIllegalL === 0 ? [] : qIllegal,
                        investor: qInvestor.filter((item) => item.checked === true),
                        date: qDateL === 0 ? [] : qDate,
                        dayNight: qDayNightL === 2 || qDayNightL === 0 ? [] : qDayNight,
                      }),
                    })
                      .then((res) => {
                        console.log(res.status);
                        return res.json();
                      })
                      .then((data) => {
                        console.log(data);
                        if (data.rows) {
                          setUSERLIST(data.rows);
                          setInvestigations(
                            data.rows.reduce((ac, val, index) => {
                              return { ...ac, [val.idx]: { latitude: val.latitude, longitude: val.longitude } };
                            }, {})
                          );
                        }
                      });
                  }}
                >
                  세부 검색
                </Button>
              </Stack>
            </div>
          </Collapse>
          <br />
          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <UserListHead
                  order={order}
                  orderBy={orderBy}
                  headLabel={TALBE_HEAD2}
                  rowCount={USERLIST.length}
                  numSelected={selected.length}
                  onRequestSort={handleRequestSort}
                  onSelectAllClick={handleSelectAllClick}
                />
                <TableBody>
                  {filteredUsers.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                    const { idx, carNum, carType, illegal, gradient, longitude, latitude, investor, date, dayNight } = row;
                    const selectedUser = selected.indexOf(idx) !== -1;
                    const carTypeShow = getCarTypeName(carType);
                    let illegalShow = '';
                    switch (illegal) {
                      case 1:
                        illegalShow = '주차면(적법)';
                        break;
                      case 2:
                        illegalShow = '흰색선(적법)';
                        break;
                      case 3:
                        illegalShow = '이면도로(적법)';
                        break;
                      case 4:
                        illegalShow = '나대지(적법)';
                        break;
                      case 5:
                        illegalShow = '황색실선/점선(불법)';
                        break;
                      case 6:
                        illegalShow = '보도 위(불법)';
                        break;
                      case 7:
                        illegalShow = '기타(불법)';
                        break;
                      default:
                        illegalShow = illegal;
                        break;
                    }

                    console.log(dayjs(date).tz('Asia/Seoul'));
                    return (
                      <TableRow hover key={idx} tabIndex={-1} role="checkbox" selected={selectedUser}>
                        <TableCell component="th" scope="row" padding="none">
                          <Typography variant="subtitle2" noWrap textAlign="center">
                            {idx}
                          </Typography>
                        </TableCell>

                        <TableCell align="left">{carNum}</TableCell>

                        <TableCell align="left">{carTypeShow}</TableCell>

                        <TableCell align="left">{illegalShow}</TableCell>

                        <TableCell align="left">{gradient ?? '-'}</TableCell>

                        <TableCell align="left">
                          <TextField
                            variant="standard"
                            defaultValue={investigations[idx].longitude}
                            onChange={(e) => {
                              setInvestigations({
                                ...investigations,
                                [idx]: {
                                  longitude: e.target.value,
                                  latitude: investigations[idx].latitude,
                                },
                              });
                            }}
                          />
                        </TableCell>
                        <TableCell align="left">
                          <TextField
                            variant="standard"
                            defaultValue={investigations[idx].latitude}
                            onChange={(e) => {
                              setInvestigations({
                                ...investigations,
                                [idx]: {
                                  longitude: investigations[idx].longitude,
                                  latitude: e.target.value,
                                },
                              });
                            }}
                          />
                        </TableCell>
                        <TableCell align="left">{investor}</TableCell>
                        <TableCell align="left">{dayjs(date).format('YYYY/MM/DD/HH:mm')}</TableCell>
                        <TableCell align="left">{dayNight === 0 ? '주간' : '야간'}</TableCell>
                        <TableCell align="right">
                          <IconButton
                            size="large"
                            color="inherit"
                            onClick={() => updateInvestigation({ idx, investigations })}
                          >
                            <Iconify icon={'eva:edit-2-outline'} sx={{ mr: 2 }} />
                          </IconButton>
                        </TableCell>
                        <TableCell align="right">
                          <IconButton size="large" color="inherit" onClick={() => deleteInvestigation(idx)}>
                            <Iconify icon={'eva:trash-2-outline'} sx={{ mr: 2 }} />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                  {emptyRows > 0 && (
                    <TableRow style={{ height: 76.59 * emptyRows }}>
                      <TableCell colSpan={6} />
                    </TableRow>
                  )}
                </TableBody>

                {isNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        <Paper
                          sx={{
                            textAlign: 'center',
                          }}
                        >
                          <Typography variant="h6" paragraph>
                            찾을 수 없습니다.
                          </Typography>

                          <Typography variant="body2">
                            <strong>&quot;{filterName}&quot;</strong>에 대한 결과가 없습니다.
                            <br /> 오타가 있는지 확인하거나 단어를 끝까지 입력해주세요.
                          </Typography>
                        </Paper>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={filteredUsers.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            labelRowsPerPage="페이지 당 개수"
          />
        </Card>
      </Container>

      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleCloseMenu}
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            p: 1,
            width: 140,
            '& .MuiMenuItem-root': {
              px: 1,
              typography: 'body2',
              borderRadius: 0.75,
            },
          },
        }}
      >
        <MenuItem>
          <Iconify icon={'eva:edit-fill'} sx={{ mr: 2 }} />
          수정
        </MenuItem>

        <MenuItem sx={{ color: 'error.main' }}>
          <Iconify icon={'eva:trash-2-outline'} sx={{ mr: 2 }} />
          삭제
        </MenuItem>
      </Popover>
    </>
  );
}
/*
<TableRow>
                    <TableCell>
                      <IconButton
                        size="large"
                        color="inherit"
                        onClick={() => {
                          setQInvestor([...qInvestor, { checked: true, id: qId }]);
                          setQId('');
                        }}
                      >
                        <Iconify icon={'eva:plus-outline'} sx={{ mr: 2 }} />
                      </IconButton>
                    </TableCell>
                    <TableCell>
                      <TextField
                        variant="standard"
                        key={qInvestor.length}
                        defaultValue={qId}
                        onChange={(e) => setQId(e.target.value)}
                      />
                    </TableCell>
                  </TableRow>
*/
